// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1nvG7","content":"RecentSearches_content__2G0zu"};